import { IsDefined, IsNumber, IsNumberString } from 'class-validator';
import { computed } from 'mobx';

import { factory, OData, $data } from 'src/core/services/data/JayDataContext';
import { ContextService } from 'src/core/services/context.service';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';
import { FormatService } from 'src/core/services/format.service';
import { EntityModel } from 'src/core/services/data/models';

export class CurrencyExchangeRateListDataService extends DataService<typeof Model.Products.Logic.ViewModels.CurrencyExchangeRateItem, Model.Products.Logic.ViewModels.CurrencyExchangeRateItem, CurrencyExchangeRateItem> {
    private id = -1;

    constructor(contextService: ContextService, entitySet: (context: OData.Container) => $data.EntitySet<typeof Model.Products.Logic.ViewModels.CurrencyExchangeRateItem, Model.Products.Logic.ViewModels.CurrencyExchangeRateItem>, private formatService: FormatService) {
        super(contextService, entitySet);
    }

    protected map(entity: Model.Products.Logic.ViewModels.CurrencyExchangeRateItem): CurrencyExchangeRateItem {
        return new CurrencyExchangeRateSummaryModel(entity, this.formatService);
    }

    public static make(context?: any, formatService?: FormatService): CurrencyExchangeRateListDataService {
        return new CurrencyExchangeRateListDataService(context, ctx => ctx.CurrencyExchangeRates, formatService);
    }

    public add(date: Date, mode: number) {
        const entity = new Model.Products.Logic.ViewModels.CurrencyExchangeRateItem();
        entity.bookingDateFrom = date;
        entity.bookingDateTo = date;
        entity.serviceDateFrom = date;
        entity.serviceDateTo = date;
        entity.mode = mode;
        entity.id = this.id--;

        return entity;
    }
}

export class CurrencyExchangeRateSummaryModel extends EntityModel<Model.Products.Logic.ViewModels.CurrencyExchangeRateItem, CurrencyExchangeRateItem> implements CurrencyExchangeRateItem {
    @property<CurrencyExchangeRateSummaryModel>(o => o.entity.id, (o, value) => o.entity.id = value)
    public id: number;

    @property<CurrencyExchangeRateSummaryModel>(o => o.entity.fromCurrencyId, (o, value) => o.entity.fromCurrencyId = value)
    public fromCurrencyId: number;

    @property<CurrencyExchangeRateSummaryModel>(o => o.entity.toCurrencyId, (o, value) => o.entity.toCurrencyId = value)
    public toCurrencyId: number;

    @property<CurrencyExchangeRateSummaryModel>(o => o.entity.rate, (o, value) => o.entity.rate = value)
    public rate: number;

    @property<CurrencyExchangeRateSummaryModel>(o => o.entity.mode, (o, value) => o.entity.mode = value)
    public mode: number;

    @property<CurrencyExchangeRateSummaryModel>(o => o.entity.bookingDateFrom, (o, value) => o.entity.bookingDateFrom = value)
    public bookingDateFrom: Date;

    @computed
    public get bookingDateFromText(): string {
		return this.formatService.toString('short-date', this.bookingDateFrom, "utc");
    }

    @property<CurrencyExchangeRateSummaryModel>(o => o.entity.bookingDateTo, (o, value) => o.entity.bookingDateTo = value)
    public bookingDateTo: Date;

    @computed
    public get bookingDateToText(): string {
		return this.formatService.toString('short-date', this.bookingDateTo, "utc");
    }

    @property<CurrencyExchangeRateSummaryModel>(o => o.entity.serviceDateFrom, (o, value) => o.entity.serviceDateFrom = value)
    public serviceDateFrom: Date;

    @computed
    public get serviceDateFromText(): string {
		return this.formatService.toString('short-date', this.serviceDateFrom, "utc");
    }

    @property<CurrencyExchangeRateSummaryModel>(o => o.entity.serviceDateTo, (o, value) => o.entity.serviceDateTo = value)
    public serviceDateTo: Date;

    @computed
    public get serviceDateToText(): string {
		return this.formatService.toString('short-date', this.serviceDateTo, "utc");
    }

    constructor(entity: Model.Products.Logic.ViewModels.CurrencyExchangeRateItem, private formatService: FormatService) {
        super(entity);
    }
}



// WEBPACK FOOTER //
// ./src/app/products/currency-exchange-rates/list/currency-exchange-rate-list.data.ts